import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import ReactPhoneNumberInput from "react-phone-number-input";
import flags from "react-phone-number-input/flags";
// import CountrySelectNative from "./PhoneInputCountrySelect";
import "react-phone-number-input/style.css";
import "../styles/PhoneInput.scss";

function PhoneInput(props) {
  let {
    meta: { error, touched, dirty },
    shouldHide,
    readOnly,
    width,
    input,
    visibility,
    disabledViaReuse,
  } = props;
  let formApi = props.formApi;
  const [value, setValue] = React.useState(input.value);
  let showError = (error && touched) || (error && dirty);

  const isConditionalField =
    visibility && visibility.requires && visibility.requires.length > 0;

  let formRowClasses = classNames("form-row-dimension", {
    [`mobile-lg:grid-col-10`]: true,
  });

  let inputRowClasses = classNames("form-row-dimension", {
    [`mobile-lg:grid-col-${width}`]: true,
  });

  let inputClasses = classNames("usa-input", {
    "usa-input-error": showError,
    "usa-input-disabled": readOnly || shouldHide || disabledViaReuse,
  });

  let wrapperClass = classNames("grid-row", "grid-gap", {
    "input-hide": shouldHide === true,
    "input-conditional": isConditionalField,
  });
  let applyValueFormat =
    input.value.length === 0 || input.value.indexOf("+") > -1
      ? input.value
      : `+${input.value}`;
  return (
    <div className={wrapperClass}>
      <div className={formRowClasses}>
        <div className={inputRowClasses}>
          <ReactPhoneNumberInput
            name={input.name}
            id={input.name}
            className={inputClasses}
            value={applyValueFormat}
            flags={flags}
            disabled={!!disabledViaReuse}
            defaultCountry="US"
            key={input.value}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                // for crossbrowser
                e.preventDefault(); // this code prevents other buttons triggers use this
              }
            }}
            onChange={(val) => {
              setValue(val);
            }}
            tabIndex={0}
            onBlur={(e) => {
              formApi.mutators.setFieldTouched(input.name, true);
              input.onChange(value);
            }}
            limitMaxLength={true}
          />
        </div>
      </div>
    </div>
  );
}

PhoneInput.defaultProps = {
  id: Math.floor(Math.random() * 100000),
  label: "Extension",
  width: 10,
  // error: false, //@todo remove
  // errorMessage: "Helpful error message",
  toolTip: true,
  toolTipContent:
    "There is an error displaying this tooltip. Contact the system administrator.",
};

PhoneInput.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // error: PropTypes.bool,
  // errorMessage: PropTypes.string,
  toolTip: PropTypes.bool,
  toolTipContent: PropTypes.string,
  label: PropTypes.string.isRequired,
  width: PropTypes.number,
};

export default PhoneInput;
